import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { storeAuthToken } from "../api/auth";

export default function Login() {
  const navigate = useNavigate();
const [showPassword, setShowPassword] = useState(false);
  const handleLogin = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const username = formData.get("username");
    const password = formData.get("password");

    try {
      const validUsername = process.env.REACT_APP_ADMIN_USERNAME;
      const validPassword = process.env.REACT_APP_ADMIN_PASSWORD;

      if (username === validUsername && password === validPassword) {
        storeAuthToken("dummy-token-for-excel-bypass");
        navigate("/dashboard");
      } else {
        throw new Error("Invalid credentials");
      }
    } catch (error) {
      console.error(error);
      alert("Unable to login. Please check your credentials and try again.");
    }
  };

  return (
 <div className="h-screen w-screen bg-[#F3F6FB]">
  <div className="flex h-full w-full overflow-hidden bg-white">

    {/* Left Image */}
    <div className="hidden h-full md:block md:w-1/2">
      <img
        src="/login-image.jpeg"
        alt="login visual"
        className="h-full w-full object-cover"
      />
    </div>

    {/* Right Side */}
    <div className="flex w-full flex-col justify-center px-10 md:w-1/2 lg:px-24">
      
      {/* Form Container */}
      <div className="mx-auto w-full max-w-[420px]">

        {/* Logo */}
        <img
          src="/Icon.svg"
          alt="logo"
          className="mx-auto mb-8 h-auto w-[280px] object-contain"
        />

        {/* Title */}
        <div className="mb-8 text-center">
          <h2 className="text-[34px] font-bold text-[#111827]">
            Welcome Back
          </h2>

          <p className="mt-2 text-[15px] text-gray-500">
            Login to your account
          </p>
        </div>

        {/* Form */}
        <form className="space-y-5" onSubmit={handleLogin}>

          {/* Email */}
          <div>
            <label className="mb-2 block text-[14px] font-medium text-gray-700">
              Username / Email
            </label>

            <input
              type="text"
              name="username"
              placeholder="Enter your email"
              className="h-[48px] w-full rounded-xl border border-gray-300 px-4 text-[14px] outline-none transition focus:border-[#129BD7] focus:ring-2 focus:ring-[#129BD7]/20"
            />
          </div>

          {/* Password */}
          <div>
            <label className="mb-2 block text-[14px] font-medium text-gray-700">
              Password
            </label>

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter password"
                className="h-[48px] w-full rounded-xl border border-gray-300 px-4 pr-11 text-[14px] outline-none transition focus:border-[#129BD7] focus:ring-2 focus:ring-[#129BD7]/20"
              />

              <button
                type="button"
                onClick={() =>
                  setShowPassword(!showPassword)
                }
                className="absolute inset-y-0 right-3 flex items-center text-gray-500"
              >
                {showPassword ? (
                  <EyeOff size={18} />
                ) : (
                  <Eye size={18} />
                )}
              </button>
            </div>
          </div>

          {/* Forgot */}
          <div className="flex justify-end">
            <button
              type="button"
              className="text-[13px] font-medium text-[#129BD7] hover:underline"
            >
              Forgot Password?
            </button>
          </div>

          {/* Login */}
          <button
            type="submit"
            className="h-[48px] w-full rounded-xl bg-[#129BD7] text-[15px] font-semibold text-white transition hover:bg-[#1088BE]"
          >
            Login
          </button>

          {/* Divider */}
          <div className="relative py-1">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200" />
            </div>

            <div className="relative flex justify-center">
              <span className="bg-white px-4 text-[13px] text-gray-400">
                OR
              </span>
            </div>
          </div>

          {/* Google */}
          <button
            type="button"
            className="flex h-[48px] w-full items-center justify-center gap-2 rounded-xl border border-gray-300 text-[14px] font-medium text-gray-700 transition hover:bg-gray-50"
          >
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt="google"
              className="h-5 w-5"
            />

            Sign in with Google
          </button>
        </form>

        {/* Footer */}
        <p className="mt-8 text-center text-[14px] text-gray-500">
          Don&apos;t have an account?
          <span className="ml-1 cursor-pointer font-medium text-[#129BD7] hover:underline">
            Sign up
          </span>
        </p>
      </div>
    </div>
  </div>
</div>
  );
}
